const DIVE_TYPE = ["Surface", "Wet bell", "Bell bounce", "Bell sat"];

export default DIVE_TYPE;
